import "./ButtonLoader.scss";
import {ReactNode} from "react";
import {useI18n} from "../../i18n/I18nProvider";
import {useMinSpin} from "../../hooks/useMinSpin";

interface IButtonLabel {
    loading: boolean,
    loadingText?: string,
    children: ReactNode,
}

// Вміст кнопки: у стані завантаження — спінер і підпис, інакше звичайний текст.
// Саму кнопку при завантаженні варто позначити класом "btn-loading" (див. ButtonLoader.scss).
export const ButtonLabel = ({ loading, loadingText, children }: IButtonLabel) => {
    const { t } = useI18n();
    // спінер видно щонайменше пів секунди, навіть якщо сервер відповів миттєво
    const spinning = useMinSpin(loading);

    if (!spinning) return <>{children}</>;

    return (
        <span className="btn-label-loading">
            <span className="btn-spinner" aria-hidden="true" />
            {loadingText ?? t("common.loading")}
        </span>
    );
};

export default ButtonLabel;
